export default __webpack_public_path__ + "static/media/630.32c57e59.svg";